import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-0"}],["path",{"d":"M8 12l4 4","key":"svg-1"}],["path",{"d":"M12 8v8","key":"svg-2"}],["path",{"d":"M16 12l-4 4","key":"svg-3"}]]

const IconCircleArrowDown = createReactComponent('outline', 'circle-arrow-down', 'CircleArrowDown', __iconNode);

export default IconCircleArrowDown;